import { RootEntityType, Thread, useGetThreadQuery } from '@schooly/api';
import { useSearchParams } from 'react-router-dom';
import { validate } from 'uuid';

type UseThreadFromQueryStringProps = {
  schoolId: string;
  rootEntityType: RootEntityType;
  rootEntityId: string;
  onThreadNotFound: () => void;
  onThreadFound: (thread: Thread) => void;
};

export const useThreadFromQueryString = ({
  schoolId,
  rootEntityType,
  rootEntityId,
  onThreadNotFound,
  onThreadFound,
}: UseThreadFromQueryStringProps) => {
  const [params] = useSearchParams();
  const id = params.get('id') ?? '';
  const isIdValidUuid = validate(id);

  const { isFetching: isThreadFetching, data: thread } = useGetThreadQuery(
    {
      school_id: schoolId,
      thread_id: id!,
    },
    {
      enabled: isIdValidUuid,
      refetchOnMount: true,

      onSuccess: (thread) => {
        rootEntityType === thread.root_entity_type && rootEntityId === thread.root_entity_id
          ? onThreadFound(thread)
          : onThreadNotFound();
      },
      onError: onThreadNotFound,
    },
  );

  return {
    isThreadFetching,
    thread,
  };
};
